// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3YrDP","checkboxCol":"Table_checkboxCol__FWZs2","emailCol":"Table_emailCol__3Oozf","actionCol":"Table_actionCol__3nW5y"};